import { observer } from 'mobx-react-lite';
import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import EventLabel from '../EventLabel/EventLabel';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const ValidationSnackbar = observer((props: any) => {
  const {
    modules,
    environment,
    fields,
    modulesRefs,
    globalAlert,
    questions,
    breakouts,
    current,
    validate,
    triggerValidation,
    checkInvoiceValidation,
    getFilteredValidations,
  } = props;

  let valids = getFilteredValidations();
  let isValid = checkInvoiceValidation(valids.length == 0);
  const filteredValidations = getFilteredValidations();

  const getLabel = module => {
    switch (module.type) {
      case 'CUSTOMFIELD': {
        // A custom field's display label lives on the module settings (editable), falling back to the
        // Field row's own label. Without this case the switch's default returned null → a blank name.
        // The LinkedIn field is always called "LinkedIn" (see CustomField.tsx).
        if (module.settings?.type === 'linkedIn' && module.settings?.linkedInField === true) return 'LinkedIn';
        if (module.settings?.label) return module.settings.label;
        const cfLang = fields.find(f => f.fieldId == module.settings.fieldId)?.fieldLanguage;
        return cfLang?.find(fl => fl.languageCode === environment.lang)?.label || cfLang?.find(fl => fl.languageCode === 'eng')?.label;
      }
      case 'FIELD': {
        const fieldLanguage = fields.find(f => f.fieldId == module.settings.fieldId)?.fieldLanguage;

        return (
          fieldLanguage?.find(fl => fl.languageCode === environment.lang)?.label ||
          fieldLanguage?.find(fl => fl.languageCode === 'eng')?.label ||
          fieldLanguage?.fieldLanguage?.[0]?.label
        );
      }

      case 'QUESTION': {
        const questionLanguage = questions.find(f => f.questionId === module.settings.questionId)?.questionLanguage;

        return (
          questionLanguage?.find(fl => fl.languageCode === environment.lang)?.label ||
          questionLanguage?.find(fl => fl.languageCode === 'eng')?.label ||
          questionLanguage?.[0]?.label
        );
      }

      case 'EVENT':
        return breakouts.find(f => f.eventId === module.settings.eventId)?.name;
      default:
        return null;
    }
  };

  const scrollToNonValidModule = contentModuleId => {
    if (!modulesRefs?.current) return;
    modulesRefs?.current?.[contentModuleId]?.scrollIntoView({
      block: 'end',
      behavior: 'smooth',
    });
  };

  if (globalAlert) {
    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={true} onClose={() => null}>
      <Alert severity="error" style={{ maxWidth: 370 }}>
        {globalAlert}
      </Alert>
    </Snackbar>;
  }

  return !isValid && validate ? (
    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={true} onClose={() => triggerValidation(false)}>
      <Alert severity="error" style={{ maxWidth: 370 }}>
        {filteredValidations
          .filter(v => (v.page === current.activePage || v.page === 0) && v.valid == false && !v.hidden)
          .map(v => {
            const module = modules.find(m => m.contentModuleId == v.id && (m.settings.validation || v.label));

            if (v.id.toString().includes('INVOICE_') || v.label === 'PaymentOption') {
              return (
                <div
                  key={v.id}
                  onClick={() => scrollToNonValidModule(modules.find(m => m.type == 'PAYMENT_OPTIONS' || m.type == 'PAYMENT_OPTIONS_TWO')?.contentModuleId)}
                  className="validation-line"
                >
                  * <EventLabel name={'Invoice' + v.label} groupName="Form.Validation" />
                </div>
              );
            }
            if (v.valid === false && v.label === 'HotelValidation') {
              return (
                <div
                  key={v.id}
                  onClick={() => scrollToNonValidModule(modules.find(m => m.type == 'HOTEL_MODULE')?.contentModuleId)}
                  className="validation-line"
                >
                  * <EventLabel name={'HOTEL_MODULE' + v.reason} groupName="Form.Validation" />
                </div>
              );
            }
            if (v.valid === false && v.label === 'FileUploaderValidation') {
              return (
                <div
                  key={v.id}
                  onClick={() => scrollToNonValidModule(modules.find(m => m.type == 'FILE_UPLOADER')?.contentModuleId)}
                  className="validation-line"
                >
                  * <EventLabel name={'FILE_UPLOADER' + v.reason} groupName="Form.Validation" />
                </div>
              );
            }
            if (module && v.valid == false) {
              let vMessage = null;
              if (v.reason && module.settings.validation[v.reason] && module.settings.validation[v.reason][environment.lang])
                vMessage = module.settings.validation[v.reason][environment.lang];
              return (
                <div key={v.id} onClick={() => scrollToNonValidModule(module.contentModuleId)} className="validation-line">
                  * <strong>{v.label || getLabel(module)}:</strong>{' '}
                  {v.message ||
                    (vMessage ? (
                      vMessage
                    ) : (
                      // A custom field reuses the stock FIELD validation messages (FIELDrequired,
                      // FIELDminLength, …); its own "CUSTOMFIELD…" keys aren't seeded. FIELDlinkedin
                      // isn't seeded either, so it falls back to English until someone translates it.
                      <EventLabel
                        name={(module.type === 'CUSTOMFIELD' ? 'FIELD' : module.type) + v.reason}
                        groupName="Form.Validation"
                        defaultValue={v.reason === 'linkedin' ? 'The link must be a linkedin.com address' : null}
                      />
                    ))}
                </div>
              );
            }
            if (v?.decorator) {
              return (
                <div key={v.id} className="validation-line">
                  * <EventLabel name={'RequiredField' + v.decorator} groupName="Form.Validation" />
                </div>
              );
            }
            return null;
          })}
      </Alert>
    </Snackbar>
  ) : null;
});
